import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FixturesRoutingModule } from './fixtures-routing.module';
import { FixturePageComponent } from './fixture-page/fixture-page.component';
import { GeneralModule } from '../general/general.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { MatchListBlockComponent } from './match-list-block/match-list-block.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { FormsModule } from '@angular/forms';
import { BookPipesModule } from '../book-pipes/book-pipes.module';
import { OddsDisclaimerComponent } from '../general/odds-disclaimer/odds-disclaimer.component';

@NgModule({
  declarations: [
	FixturePageComponent,
	MatchListBlockComponent,
  ],
  imports: [
	CommonModule,
	FixturesRoutingModule,
	GeneralModule,
	SidebarModule,
	FontAwesomeModule,
	MatDatepickerModule,
	FormsModule,
	MatNativeDateModule,
	BookPipesModule,
	OddsDisclaimerComponent,
  ],
  exports: [
	MatchListBlockComponent
  ],
})
export class FixturesModule { }
